module.exports = __webpack_public_path__ + "media/images/icons/icon_512-ac9086a12ec692428baabc4a3e73a615.png";